import React from 'react';
import { Alert } from 'antd';
import { useIsOrgAdmin } from '../../hooks/useIsOrgAdmin';
import { useTranslation } from '../../hooks/useTranslation';

// Trang toàn-tổ chức (báo cáo loyalty, phân khúc, chiến dịch — task 070): chỉ quản trị tổ chức. Server (RequireOrgAdmin) mới là nơi chặn thật; đây chỉ để user
// thường thấy lời giải thích thay vì lỗi 403 khó hiểu.
const AdminOnly: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isOrgAdmin = useIsOrgAdmin();
  const { t } = useTranslation();
  if (!isOrgAdmin) {
    return (
      <Alert
        style={{ margin: 24 }}
        type="warning"
        showIcon
        message={t('common.adminOnlyTitle')}
        description={t('common.adminOnlyBody')}
      />
    );
  }
  return <>{children}</>;
};

export default AdminOnly;
